import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    width?: number;
    height?: number;
    stroke?: string;
    strokeWidth?: number;
};

export const PlayIcon = ({ width = 24, height = 24, stroke = 'currentColor', strokeWidth = 2.4, ...props }: Props) => {
    const { scaleHeightPixel } = useScreenSize();

    return (
        <svg width={scaleHeightPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M5.24072 21L5.24072 2L19.7594 12.0588L14.2647 15.8657L11.5173 17.7691L10.1436 18.7208L9.45677 19.1967"
                stroke={stroke}
                strokeWidth={strokeWidth}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};
